export default __webpack_public_path__ + "static/media/s_wdt_c_0.2299c1cf.mp3";